const name = 'BaseFilter';
const properties = {};
function animate(kit, elements, duration = 0, delay = 0, params = {}) {
    return kit.engine.tween(elements, { duration, delay, ...params }, ['filter']);
}
export { name, properties, animate };
//# sourceMappingURL=baseFilter.js.map